import axios from "../../../lib/axios";

export const all = async ({ commit }, payload) => {
  try {
    payload = payload || {};
    let params = payload.params || "sort=name";
    let res = await axios.get(`/achievements?${params}`);
    commit("SET_ALL", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const create = async ({ commit }, payload) => {
  try {
    let res = await axios.post(`/achievements`, payload);
    commit("CREATE", res.data);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const read = async ({ commit, state }, payload) => {
  let local = state.all.find(x => x._id === payload.id);
  commit("SET_ITEM", local);

  // get latest
  try {
    let res = await axios.get(`/achievements/${payload.id}`);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const edit = async ({ commit, state }, payload) => {
  let local = state.all.find(x => x._id === payload.id);
  commit("SET_ITEM", local);

  // get latest
  try {
    let res = await axios.get(`/achievements/${payload.id}/edit`);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const update = async ({ commit, state }) => {
  try {
    let res = await axios.patch(
      `/achievements/${state.current._id}`,
      state.current
    );
    commit("UPDATE", res.data);
    commit("SET_ITEM", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const patch = async ({ commit }, payload) => {
  try {
    let res = await axios.patch(`/achievements/${payload._id}`, payload);
    commit("UPDATE", res.data);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const clone = async ({ commit, state }) => {
  try {
    let clone = JSON.parse(JSON.stringify(state.current));
    delete clone._id;
    if (clone.name) {
      clone.name = `${clone.name} (Copy)`;
    }
    let res = await axios.post(`/achievements`, clone);
    commit("CREATE", res.data);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const destroy = async ({ commit, state }) => {
  try {
    await axios.delete(`/achievements/${state.current._id}`);
    commit("DELETE", state.current);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};
